export const searchConstants = {
  FETCH_MAIN_SEARCH_START: 'FETCH_MAIN_SEARCH_START',
  FETCH_MAIN_SEARCH_SUCCESS: 'FETCH_MAIN_SEARCH_SUCCESS',
  FETCH_MAIN_SEARCH_FAILURE: 'FETCH_MAIN_SEARCH_FAILURE',
  CLEAR_MAIN_SEARCH: 'CLEAR_MAIN_SEARCH',
  UPDATE_MAIN_SEARCH: 'UPDATE_MAIN_SEARCH',
  REMOVE_MAIN_SEARCH: 'REMOVE_MAIN_SEARCH',

  FETCH_SUBNAV_SEARCH_START: 'FETCH_SUBNAV_SEARCH_START',
  FETCH_SUBNAV_SEARCH_SUCCESS: 'FETCH_SUBNAV_SEARCH_SUCCESS',
  FETCH_SUBNAV_SEARCH_FAILURE: 'FETCH_SUBNAV_SEARCH_FAILURE',
  CLEAR_SUBNAV_SEARCH: 'CLEAR_SUBNAV_SEARCH',
  UPDATE_SUBNAV_SEARCH: 'UPDATE_SUBNAV_SEARCH',
  REMOVE_SUBNAV_SEARCH: 'REMOVE_SUBNAV_SEARCH',

  FETCH_SEARCH_FUND_CALENDAR_START: 'FETCH_SEARCH_FUND_CALENDAR_START',
  FETCH_SEARCH_FUND_CALENDAR_SUCCESS: 'FETCH_SEARCH_FUND_CALENDAR_SUCCESS',
  FETCH_SEARCH_FUND_CALENDAR_FAILURE: 'FETCH_SEARCH_FUND_CALENDAR_FAILURE',
  CLEAR_SEARCH_FUND_CALENDAR: 'CLEAR_SEARCH_FUND_CALENDAR',
  UPDATE_SEARCH_FUND_CALENDAR: 'UPDATE_SEARCH_FUND_CALENDAR',
  REMOVE_SEARCH_FUND_CALENDAR: 'REMOVE_SEARCH_FUND_CALENDAR',
};
